import graphApiSlice from 'src/shared/state/api-slices/graphApiSlice';
import { SampleFilter } from 'src/shared/types';

import {
    SpeciesMapFilterQuery,
    SpeciesMapFilterQueryResult,
    SpeciesMapQuery,
    SpeciesMapQueryResult,
    samplesSidebarQuery,
    SpeciesMapSidebarQueryResult,
} from './queries/speciesMapQuery';
import { markersQuery, MarkersQueryResult } from './queries/markersQuery';

type SpeciesMapQueryParams = {
    projectId: string;
    samples: SampleFilter;
};

type MarkersQueryParams = {
    projectId: string;
    sampleId: string;
};

const samplesGraphSlice = graphApiSlice.injectEndpoints({
    endpoints: builder => ({
        speciesMap: builder.query<SpeciesMapQueryResult, SpeciesMapQueryParams>({
            query: params => ({
                body: SpeciesMapQuery,
                variables: params,
            }),
        }),
        speciesMapSidebar: builder.query<SpeciesMapSidebarQueryResult['samplesSidebarData'], SpeciesMapQueryParams>({
            query: params => ({
                body: samplesSidebarQuery,
                variables: params,
            }),
            transformResponse: (response: SpeciesMapSidebarQueryResult) => response.samplesSidebarData,
        }),
        speciesMapFilter: builder.query<SpeciesMapFilterQueryResult, SpeciesMapQueryParams>({
            query: params => ({
                body: SpeciesMapFilterQuery,
                variables: params,
            }),
        }),
        markers: builder.query<MarkersQueryResult, MarkersQueryParams>({
            query: params => ({
                body: markersQuery,
                variables: params,
            }),
        }),
    }),
});

export const { useSpeciesMapQuery, useSpeciesMapSidebarQuery, useSpeciesMapFilterQuery, useMarkersQuery } = samplesGraphSlice;

export default samplesGraphSlice.reducer;
